import React from "react";
import { NavLink } from "react-router-dom";
import AuthService from "services/auth.service";

import navDashboardIcon from "assets/images/icons/navDashboardIcon.svg";
import navAddIcon from "assets/images/icons/navAddIcon.svg";
import navSearchIcon from "assets/images/icons/navSearchIcon.svg";
import navUpcomingIcon from "assets/images/icons/navUpcomingIcon.svg";
import navStatisticIcon from "assets/images/icons/navStatisticIcon.svg";

let currentUser = AuthService.getCurrentUser();

const adminLinks = [
  { title: "Overview", image: navDashboardIcon, href: "/admin/dashboard" },
  {
    title: "Search Customer",
    image: navSearchIcon,
    href: "/admin/search-customer",
  },
];

const caringStoreAdminLinks = [
  { title: "Add Customer", image: navAddIcon, href: "/admin/add-customer" },
  { title: "Upcoming", image: navUpcomingIcon, href: "/admin/upcoming" },
];

const hqLinks = [
  { title: "Statistics", image: navStatisticIcon, href: "/admin/statistics" },
];

const getNavbarList = (role) => {
  let navbarList = [...adminLinks];

  if (role === "caring_store_admin") {
    navbarList = navbarList.concat(caringStoreAdminLinks);
  }

  if (role === "healthlane_hq" || role === "mog_hq") {
    navbarList = navbarList.concat(hqLinks);
  }

  return navbarList;
};

const parentNavbarList = getNavbarList(currentUser?.role);

const toggleMobileDropdown = (props) => {
  props.triggerDropdown && props.triggerDropdown();
};

export const SidebarLinks = (props) => {
  const navbarElements = parentNavbarList.map((hash, index) => {
    return (
      <NavLink
        key={index}
        to={hash.href}
        className={({ isActive }) =>
          "nav-link p-0" + (isActive ? " is-active" : "")
        }
        onClick={() => toggleMobileDropdown(props)}
      >
        <nav
          key={"sidebar-link-" + hash.title}
          className="d-flex align-items-center ps-4 py-3"
        >
          <img
            src={hash.image}
            alt={hash.title}
            className="ms-2 me-3 nav-icon"
          />
          {hash.title}
        </nav>
      </NavLink>
    );
  });

  return navbarElements;
};
